import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ContactsModal } from '../ContactsModal';

const ContactsSection = memo(({ residence, onClickHandler, phonesShown }) => {
  const { t } = useTranslation();
  const [showContacts, setShowContacts] = useState(false);

  const clickHandler = e => {
    onClickHandler(0, true)(e, 'contact');
    setShowContacts(true);
  };

  const scrollHandler = el => {
    document
      .getElementsByClassName(el)[0]
      .scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="contacts-container">
      <div className="contacts">
        <div className="contacts__title">{residence.name}</div>
        <div className="contacts-i">
          <div
            className="contacts-i__items"
            data-stat="residence-contacts"
            onClick={clickHandler}
            onKeyPress={clickHandler}
            role="button"
            tabIndex="0"
          >
            {t('residences.numbers')}
          </div>
          {residence.apartments?.length > 0 && (
            <div
              className="contacts-i__items"
              data-stat="residence-layouts"
              onClick={() => scrollHandler('ap-filter')}
              onKeyPress={clickHandler}
              role="button"
              tabIndex="0"
            >
              {t('residences.apartments')}
            </div>
          )}
          {residence.itemsCount > 0 && (
            <div
              className="contacts-i__items"
              data-stat="residence-flats"
              onKeyPress={null}
              onClick={() => scrollHandler('residence-items__container')}
              role="button"
              tabIndex="0"
            >
              {t('residences.items')}
            </div>
          )}
        </div>
      </div>

      {showContacts && (
        <ContactsModal
          phonesShown={phonesShown || residence.phonesMasked}
          isOpen={showContacts}
          onClose={() => setShowContacts(false)}
          contactEmail={residence.contactEmail}
          website={residence.website}
        />
      )}
    </div>
  );
});

ContactsSection.displayName = `ContactsSection`;

ContactsSection.propTypes = {
  residence: PropTypes.object,
  phonesShown: PropTypes.array,
  onClickHandler: PropTypes.func
};

export default ContactsSection;
